import React from "react";
import PropTypes from "prop-types";

import lodashGet from "lodash.get";

import { Img } from "arv-reactcomponents";

import { deduceValuesFromPipedData, imageFileName } from "../../../utils";
import Anchor from "../../../component/Anchor";

const SpecialBannerComponent = props => {
  const {
    bannerObject,
    bannerContainerClassName,
    bannerImgClassName,
    bannerButtonClassName,
  } = props;

  const bannerData = lodashGet(bannerObject, "banner.list");

  if (bannerData && bannerData.length) {
    return bannerData.map(banner => (
      <div key={banner.id} className={bannerContainerClassName}>
        {banner.image.path ? (
          <Img
            src={banner.image.path}
            className={bannerImgClassName}
            alt={imageFileName(banner.image.path)}
          />
        ) : null}
        <Anchor.component
          className={`nwc-btn ${bannerButtonClassName}`}
          target="_blank"
          to={deduceValuesFromPipedData(banner.pcmData).url || "/"}
          href={deduceValuesFromPipedData(banner.pcmData).url || "/"}
        >
          {banner.cta}
        </Anchor.component>
      </div>
    ));
  }

  return null;
};

SpecialBannerComponent.propTypes = {
  bannerObject: PropTypes.shape({}).isRequired,
  bannerContainerClassName: PropTypes.string.isRequired,
  bannerImgClassName: PropTypes.string.isRequired,
  bannerButtonClassName: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: SpecialBannerComponent,
  component: SpecialBannerComponent,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/SpecialBannerComponent/index.js